export const contentTableConfig = {
  title: '积分扣除项列表',
  propList: [
    {
      prop: 'reason',
      label: '原因',
      minWidth: '80'
    },
    {
      prop: 'flow',
      label: '流向',
      minWidth: '80',
      slotName: 'flow'
    },
    {
      prop: 'point',
      label: '积分数量',
      minWidth: '80'
    },
    {
      label: '操作',
      minWidth: '120',
      slotName: 'handler'
    }
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
